import {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { Search, FileCopy } from "@material-ui/icons";
import { AppContext } from "./../contexts/appContext";
import { setpriceAPI } from "../services/SetPriceService";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Autocomplete } from "@mui/material";
import moment from "moment";
import Download from "downloadjs";

const Set_Price = () => {
  const { user } = useContext(AppContext);
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [promotion, setPromotion] = useState([]);
  const [NickName_BU, setNickName_BU] = useState([]);
  const [allCat, setAllCat] = useState([]);
  const [cat, setCat] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    let date = moment().subtract(1, "month").utcOffset(0);
    date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    return date.toDate();
  });
  const [endDate, setEndDate] = useState(() => {
    let date = moment().add(1, "month").utcOffset(0);
    date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    return date.toDate();
  });
  const searchRef = useRef({ name: "", count: 0 });

  const getPormotion = useCallback(
    async (newPage) => {
      try {
        if (search == searchRef.current.name) {
          searchRef.current.count = searchRef.current.count + 1;
        } else {
          searchRef.current.name = search;
          searchRef.current.count = 1;
        }
        const { status, message } = await setpriceAPI.getSetPrice({
          page: newPage || page,
          cat,
          code: search,
          startDate,
          endDate,
        });
        if (status == 200 && message?.message instanceof Array) {
          setTotal(message?.meta?.count || 0);
          if (Array.isArray(message.group_cat)) {
            let gc = message.group_cat.map((res) => res._id).filter((res)=>!!res);
            setAllCat(gc);
          }
          setPromotion(message.message);
        } else throw { message };
      } catch (error) {
        alert(error.message);
      }
    },
    [page, cat, search, startDate, endDate]
  );

  const exportExcel = useCallback(() => {
    if (!loading) {
      setLoading(true);
      setpriceAPI
        .getSetPriceExcel({
          cat,
          code: search,
          startDate,
          endDate,
        })
        .then((response) => {
          Download(
            response.data,
            `SetPrice.xlsx`,
            response.headers["content-type"]
          );
          setLoading(false);
        })
        .catch((error) => {
          alert(error.message);
          setLoading(false);
        });
    }
  }, [loading, page, cat, search, startDate, endDate]);

  const maxPage = useMemo(() => {
    return Math.ceil(total / 10);
  }, [total]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (user) {
      getPormotion();
    }
    return () => {
      if (!user) {
        setPromotion([]);
      }
    };
  }, [user, cat, page, startDate, endDate]);

  useEffect(() => {
    searchRef.current.name = "";
    searchRef.current.count = 0;
  }, [search]);

  // useEffect(() => {
  //   setLoading(true);
  //   setpriceAPI
  //     .getGroup_BU({ status: "YES" })
  //     .then((res) => {
  //       if (res.status != 200) throw { message: res.message };
  //       if (Array.isArray(res.message)) {
  //         setNickName_BU(res.message);
  //       }
  //     })
  //     .catch(() => {
  //       alert(error.message);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, []);

  const handleSearch = async () => {
    if (searchRef.current.count < 3) {
      getPormotion(0);
      setPage(0);
    }
  };

  return (
    <>
      <Box className="container-promotion">
        <Typography variant="h5" gutterBottom component="div">
          Set Price{" "}
          {!!user?.excel_set_price && (
            <FileCopy
              onClick={exportExcel}
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: loading ? "red" : "black",
              }}
            />
          )}
        </Typography>
        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item xs>
            <Autocomplete
              options={allCat}
              value={cat || null}
              onChange={(event, newValue) => {
                setCat(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Cat..."
                  variant="outlined"
                  style={{ margin: "auto" }}
                  color="primary"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={4} style={{ margin: "auto" }}>
            <TextField
              variant="outlined"
              label="ค้นหา"
              style={{ margin: "auto" }}
              color="primary"
              fullWidth
              value={search || ""}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={(e) => {
                if (e.charCode == 13) {
                  handleSearch();
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search
                      style={{ cursor: "pointer" }}
                      onClick={handleSearch}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid style={{ gap: "2px", margin: "auto" }}>
            {/* <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="เริ่มต้น"
                  inputFormat="dd/MM/yyyy"
                  value={startDate}
                  onChange={(newDate) => setStartDate(newDate)}
                  maxDate={endDate}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
                <DesktopDatePicker
                  label="สิ้นสุด"
                  inputFormat="dd/MM/yyyy"
                  value={endDate}
                  onChange={(newDate) => setEndDate(newDate)}
                  minDate={startDate}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </LocalizationProvider>
            </Box> */}
          </Grid>
        </Grid>
        <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#bbf7d0" }}
                >
                  ชื่อคนส่ง Set Price
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#fde68a" }}
                >
                  วันที่มีผล
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#fde68a" }}
                >
                  วันที่สิ้นสุด Promotion
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#bbf7d0" }}
                >
                  Category
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#bbf7d0" }}
                >
                  Sub Category
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#bbf7d0" }}
                >
                  Brand
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#ffedd5" }}
                >
                  Product
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#ffedd5" }}
                >
                  Product Name
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ backgroundColor: "#bbf7d0", color: "red" }}
                >
                  Cost FC ราคาที่ให้ FC
                </TableCell>
                <TableCell
                  className="table-header-promotion-no-c"
                  style={{ color: "white", backgroundColor: "#fb7185" }}
                >
                  SRP{" "}
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ color: "white", backgroundColor: "#fed7aa" }}
                >
                  Min
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ color: "white", backgroundColor: "#fed7aa" }}
                >
                  %GP
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ color: "white", backgroundColor: "#a5f3fc" }}
                >
                  BU ที่ต้องการ Set ราคา
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ color: "white", backgroundColor: "#93c5fd" }}
                >
                  ระบุ ID
                </TableCell>
                <TableCell
                  className="table-header-promotion"
                  style={{ color: "white", backgroundColor: "#a5b4fc" }}
                >
                  Promotion โดยการ Set Price
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {promotion.map((res) =>
                !!res.SRP_MIN?.length ? (
                  res.SRP_MIN.map((rex) => (
                    <TableRow
                      key={`${res._id}-${rex.name_bu}`}
                      className="table-row-promotion"
                    >
                      <TableCell className="table-cell-promotion">
                        {res.uploader}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {res["วันที่มีผล"]
                          ? moment(res["วันที่มีผล"]).format("DD MMM YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell className="table-cell-promotion mobile-promotion">
                        {res["วันที่สิ้นสุด Promotion"]
                          ? moment(res["วันที่สิ้นสุด Promotion"]).format(
                              "DD MMM YYYY"
                            )
                          : "-"}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {res.Category}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {res["Sub Category"]}
                      </TableCell>
                      <TableCell className="table-cell-promotion mobile-promotion">
                        {res["Brand"]}
                      </TableCell>
                      <TableCell className="table-cell-promotion mobile-promotion">
                        {res["Product Code"]}
                      </TableCell>
                      <TableCell className="table-cell-promotion mobile-promotion">
                        {res["Product Name"]}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {res["cost_fc"]
                          ? Number(res["cost_fc"]).toLocaleString()
                          : "-"}
                      </TableCell>
                      <TableCell
                        className="table-cell-promotion-no-c mobile-promotion"
                        style={{ color: "white", backgroundColor: "#fb7185" }}
                      >
                        {rex.srp}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {rex.min}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {rex.gp}
                      </TableCell>
                      <TableCell className="table-cell-promotion">
                        {!!rex.name_bu?.includes("G") ? rex.name_bu : ""}
                      </TableCell>
                      <TableCell className="table-header-promotion">
                        {!rex.name_bu?.includes("G") ? rex.name_bu : ""}
                      </TableCell>
                      <TableCell className="table-header-promotion">
                        {!res["วันที่สิ้นสุด Promotion"]
                          ? "ปรับถาวร"
                          : moment(res["วันที่สิ้นสุด Promotion"]).diff(
                              moment(res["วันที่มีผล"]),
                              "days"
                            ) + 1}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow key={`${res._id}-`} className="table-row-promotion">
                    <TableCell className="table-cell-promotion">
                      {res.uploader}
                    </TableCell>
                    <TableCell className="table-cell-promotion">
                      {res["วันที่มีผล"]
                        ? moment(res["วันที่มีผล"]).format("DD MMM YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell className="table-cell-promotion mobile-promotion">
                      {res["วันที่สิ้นสุด Promotion"]
                        ? moment(res["วันที่สิ้นสุด Promotion"]).format(
                            "DD MMM YYYY"
                          )
                        : "-"}
                    </TableCell>
                    <TableCell className="table-cell-promotion">
                      {res.Category}
                    </TableCell>
                    <TableCell className="table-cell-promotion">
                      {res["Sub Category"]}
                    </TableCell>
                    <TableCell className="table-cell-promotion mobile-promotion">
                      {res["Brand"]}
                    </TableCell>
                    <TableCell className="table-cell-promotion mobile-promotion">
                      {res["Product Code"]}
                    </TableCell>
                    <TableCell className="table-cell-promotion mobile-promotion">
                      {res["Product Name"]}
                    </TableCell>
                    <TableCell className="table-cell-promotion">
                      {res["cost_fc"]
                        ? Number(res["cost_fc"]).toLocaleString()
                        : "-"}
                    </TableCell>
                    <TableCell
                      className="table-cell-promotion-no-c mobile-promotion"
                      style={{ color: "white", backgroundColor: "#fb7185" }}
                    >
                      -
                    </TableCell>
                    <TableCell className="table-cell-promotion">-</TableCell>
                    <TableCell className="table-cell-promotion">-</TableCell>
                    <TableCell className="table-cell-promotion">-</TableCell>
                    <TableCell className="table-header-promotion">-</TableCell>
                    <TableCell className="table-header-promotion">-</TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {maxPage > 1 && (
          <TablePagination
            rowsPerPageOptions={[]}
            rowsPerPage={10}
            page={page}
            component="div"
            count={total}
            onChangePage={handleChangePage}
          />
        )}
        {/* <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="table-header-promotion">
                  BU ที่ต้องการ Set ราคา
                </TableCell>
                <TableCell className="table-header-promotion"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {NickName_BU.map((res) => (
                <TableRow key={res.group_name} className="table-row-promotion">
                  <TableCell className="table-cell-promotion">
                    {res.group_name}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res.bu_name}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer> */}
      </Box>
    </>
  );
};

export default Set_Price;
